<template>
  <section class="mx-4 py-2 mb-3">
    <v-row>
      <v-col cols="7" md="7" sm="12">
        <v-card style="height:100%" class="fill-height d-flex flex-column elevation-0 px-2">
          <div class="d-flex align-center">
            <v-card-title class="strong" style="line-height: .5rem;">{{ $t('flowSightOverview.kpis') }}</v-card-title>
            <a @click="redrawFilter" :style="{
              color: analyticsProStore.activeFilter !== 'ALL' ||
                isFiltered
                ? '#ffbf00' : '#808080',
              display:
                analyticsProStore.activeFilter !== 'ALL' ||
                  isFiltered
                  ? 'block' : 'none'
            }" class="text-caption" style="text-decoration: none;">{{ $t('instructions.resetFilter') }}</a>
          </div>

          <v-card-actions class="flex-grow-1">
            <div ref="kpi" class="kpis fill-height flex-grow-1">
              <div class="total-vol borders " :class="kpiTrendClass('totalVol')">
                <h5>
                  {{ $t('flowSightOverview.totalVolume') }}
                </h5>
                <div class="kpi-value-row">
                  <span class="kpi-prefix">R$</span>
                  <div id="total-vol" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('totalVol') }}</div>
              </div>

              <!-- volume negociado (DEAL + NOTH.DONE)-->
              <div class="borders vol-negociado" :class="kpiTrendClass('negotiatedVol')">
                <h5>{{ $t('flowSightOverview.negociatedVol') }}</h5>
                <div class="kpi-value-row">
                  <span class="kpi-prefix">R$</span>
                  <div id="negotiated-vol" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('negotiatedVol') }}</div>
              </div>

              <!-- volume convertido (DEAL)-->
              <div class="borders vol-convertido" :class="kpiTrendClass('convertedVol')">
                <h5>{{ $t('flowSightOverview.convertedVol') }}</h5>
                <div class="kpi-value-row">
                  <span class="kpi-prefix">R$</span>
                  <div id="converted-vol" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('convertedVol') }}</div>
              </div>

              <!-- receita total + 25% fontsize-->
              <div class="borders profit " :class="kpiTrendClass('revenue')">
                <h5> {{ $t('flowSightOverview.totalRevenue') }}</h5>
                <div class="kpi-value-row">
                  <span class="kpi-prefix">R$</span>
                  <div id="receita" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('revenue') }}</div>
              </div>

              <!--conversao volume vconvertido / volume negociado -->
              <div class="borders conversion" :class="kpiTrendClass('conversionRate')">
                <h5>{{ $t('flowSightOverview.conversion') }}</h5>
                <div class="kpi-value-row">
                  <div id="conversion-rate" class="kpi-value"></div>
                  <span class="kpi-suffix">%</span>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('conversionRate') }}</div>
              </div>

              <!-- ticket medio negociado (DEAL + NOTH.DONE) -->
              <div class="borders ticket-negociado" :class="kpiTrendClass('negotiatedTicket')">
                <h5>{{ $t('flowSightOverview.negotiatedTicket') }}</h5>
                <div class="kpi-value-row">
                  <span class="kpi-prefix">R$</span>
                  <div id="negotiated-ticket" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('negotiatedTicket') }}</div>
              </div>

              <!-- RFQs negociadas (DEAL + NOTH.DONE) -->
              <div class="borders rfq-negociada" :class="kpiTrendClass('negotiatedCount')">
                <h5>{{ $t('flowSightOverview.negotiatedCount') }}</h5>
                <div class="kpi-value-row">
                  <div id="negotiated-count" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('negotiatedCount') }}</div>
              </div>

              <!-- ticket medio convertido (DEAL) -->
              <div class="borders ticket-convertido" :class="kpiTrendClass('convertedTicket')">
                <h5>{{ $t('flowSightOverview.convertedTicket') }}</h5>
                <div class="kpi-value-row">
                  <span class="kpi-prefix">R$</span>
                  <div id="converted-ticket" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('convertedTicket') }}</div>
              </div>

              <!-- RFQs convertidas (DEAL) -->
              <div class="borders rfq-convertida" :class="kpiTrendClass('convertedCount')">
                <h5>{{ $t('flowSightOverview.convertedCount') }}</h5>
                <div class="kpi-value-row">
                  <div id="converted-count" class="kpi-value"></div>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('convertedCount') }}</div>
              </div>

              <div class="borders bps" :class="kpiTrendClass('spread')">
                <h5> {{ $t('flowSightOverview.avgSpread') }}</h5>
                <div class="kpi-value-row">

                  <div id="markup" class="kpi-value"></div>
                  <span class="kpi-suffix">pips</span>
                </div>
                <div class="kpi-var">{{ kpiVarLabel('spread') }}</div>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- bar chart-->

      <v-col cols="5" md="5" sm="12">
        <chart-card-template id="currency" @resetCurrentChart="redrawFilter"
          :active="analyticsProStore.activeFilter !== 'ALL' || isFiltered">
          <!--title-->
          <template #title>
            <div class="card-title mr-2">{{ $t('flowSightOverview.operationsByCurrency') }}</div>
          </template>
          <!--chart-->
          <template>
            <div class="flex-grow-1" ref="parentCurrency">
              <div id="currency" ref="currency">
                <div class="reset cursor-pointer" style="visibility: hidden">
                  <span class="filter"></span>
                  <a style="color: #ffbf00" class="cursor-pointer"> </a>
                </div>
              </div>
            </div>
          </template>
        </chart-card-template>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" md="4" sm="12" class="d-flex flex-column stacked-cards">
        <chart-card-template id="transactions" @resetCurrentChart="redrawFilter"
          :active="analyticsProStore.activeFilter !== 'ALL' || isFiltered">
          <!--title-->
          <template #title>
            <div class="card-title mr-2">{{ $t('flowSightOverview.volumeByStatus') }}</div>
          </template>
          <!--chart-->
          <template>
            <div class="flex-grow-1" ref="parentTransaction">
              <div class="charts-wrapp">
                <div>
                  <div id="transactions" ref="transactions">
                    <div
                      class="reset cursor-pointer"
                      style="visibility: hidden"
                    >
                      <span class="filter"></span>
                      <a style="color: #ffbf00" class="cursor-pointer"> </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </chart-card-template>

        <!-- volume por ponta (COMPRA x VENDA) -->
        <chart-card-template id="side-volume" @resetCurrentChart="redrawFilter"
          :active="analyticsProStore.activeFilter !== 'ALL' || isFiltered">
          <!--title-->
          <template #title>
            <div class="card-title mr-2">{{ $t('flowSightOverview.volumeBySide') }}</div>
          </template>
          <!--chart-->
          <template>
            <div class="flex-grow-1" ref="parentSideVolume">
              <div class="charts-wrapp">
                <div>
                  <div id="side-volume" ref="sideVolume">
                    <div
                      class="reset cursor-pointer"
                      style="visibility: hidden"
                    >
                      <span class="filter"></span>
                      <a style="color: #ffbf00" class="cursor-pointer"> </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </chart-card-template>
      </v-col>
      <v-col cols="4" md="4" sm="12" class="d-flex flex-column stacked-cards">

      <chart-card-template
          id="clients"
          @resetCurrentChart="redrawFilter"
          :active="analyticsProStore.activeFilter !== 'ALL' || isFiltered"
        >
          <!--title-->
          <template #title>
            <div class="card-title mr-2">{{ $t('flowSightOverview.clientsByNotionalRange') }}</div>
          </template>
          <!--chart-->
          <template>
            <div style="flex: auto;" ref="parentClient">
              <div class="charts-wrapp">
                <div>
                  <div id="clients" ref="clients">
                    <div
                      class="reset cursor-pointer"
                      style="visibility: hidden"
                    >
                      <span class="filter"></span>
                      <a style="color: #ffbf00" class="cursor-pointer"> </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </chart-card-template>

        <!-- clientes por faixa de vencimento (tenor) -->
        <chart-card-template
          id="clients-maturity"
          @resetCurrentChart="redrawFilter"
          :active="analyticsProStore.activeFilter !== 'ALL' || isFiltered"
        >
          <!--title-->
          <template #title>
            <div class="card-title mr-2">{{ $t('flowSightOverview.clientsByMaturityRange') }}</div>
          </template>
          <!--chart-->
          <template>
            <div style="flex: auto;" ref="parentClientMaturity">
              <div class="charts-wrapp">
                <div>
                  <div id="clients-maturity" ref="clientsMaturity">
                    <div
                      class="reset cursor-pointer"
                      style="visibility: hidden"
                    >
                      <span class="filter"></span>
                      <a style="color: #ffbf00" class="cursor-pointer"> </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </chart-card-template>
      </v-col>

      <v-col cols="4" md="4" sm="12">
        <v-card class="fill-height pb-5 elevation-0">
          <div class="d-flex align-center">
            <v-card-title class="strong" style="line-height: 0.5rem">{{ $t('flowSightOverview.rejections')
              }}</v-card-title>
            <a @click="redrawFilter" class="text-caption" :style="{
              color:
                analyticsProStore.activeFilter !== 'ALL' || isFiltered
                  ? '#ffbf00'
                  : '#808080',
              display:
                analyticsProStore.activeFilter !== 'ALL' || isFiltered
                  ? 'block'
                  : 'none',
            }" style="text-decoration: none">{{ $t('instructions.resetFilter') }}</a>
          </div>
          <p style="font-size: 0.8rem" class="ma-4">
            {{ $t('flowSightOverview.rejectionDistribution') }}{{
              totalRejected
            }}
          </p>
          <div id="pie-chart" ref="piechart" class="pb-10">
            <div class="reset cursor-pointer" style="visibility: hidden">
              <span class="filter"></span>
              <a style="color: #ffbf00" class="cursor-pointer"> </a>
            </div>
          </div>
          <div id="pie-chart-legend" ref="pieChartLegend"></div>
        </v-card>
      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0">
          <the-data-table
          :dim="dim"
          :tableData="tableData"
          :ndx="ndx"
          chart-group="flowsight-overview"
          />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import * as d3 from "d3";
import { useAnalyticsProStore } from "@/store/analyticsStore";
import crossfilter from "crossfilter2";
import * as dc from "dc";
import { mapStores } from "pinia";
import TheDataTable from "./components/TheDataTable.vue";
import ChartCardTemplate from "./components/ChartCardTemplate.vue";
import { safeRenderAll, safeRedrawAll, createScheduledRedraw, createResizeWatcher } from "./runtime/chartLifecycle";
import { createCurrencyBarChart } from "./overview/createCurrencyBarChart";
import { createStatusBarChart } from "./overview/createStatusBarChart";
import { createRejectionPieChart } from "./overview/createRejectionPieChart";
import { createClientsVolumeChart } from "./overview/createClientsVolumeChart";
import { createSideVolumeChart } from "./overview/createSideVolumeChart";
import { createClientsMaturityChart } from "./overview/createClientsMaturityChart";
import {
  createTotalVolumeKpi,
  createNegotiatedVolumeKpi,
  createConvertedVolumeKpi,
  createConversionRateKpi,
  createNegotiatedTicketKpi,
  createConvertedTicketKpi,
  createNegotiatedCountKpi,
  createConvertedCountKpi,
  createAverageSpreadKpi,
  createRevenueKpi,
} from "./overview/createKpisChart.js";
import { measureKpis, measureBenchmark, buildKpiVariations, createEffectiveSpotMap } from "./overview/kpiBenchmark.js";
import { toDate } from "@/utils/flowSightPeriods";

const CHART_GROUP = "flowsight-overview";

export default {
  components: {
    TheDataTable,
    ChartCardTemplate,
  },
  data() {
    return {
      totalRejected:0,
      ndx: null,
      tableData:{},
      data: {},
      sideColor: '#2ecc71',
      dim: {},
      isFiltered: false,
      rebuilding:false,
      // See Conversions.vue - generation of the dataset this page built from.
      builtGeneration: -1,
      _unsubStore:null,
      // { totalVol: { current, baseline, pct }, ... } - null pct renders "—".
      kpiVariations: {},
    };
  },
  created() {
    this.charts = []
    this.kpiCharts = []
    this._resizeWatcher = null
  },
  watch: {
    'analyticsProStore.datasetGeneration'() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          //console.log('analytics watch')
          this.init()
        //  dc.redrawAll();
        });
      },400);
    },
    'analyticsProStore.periodSelection': {
      immediate: false,
      deep: true,
      handler() {
        if (this.rebuilding) return;
          // Slider edits always map to TENOR filtering (not calendar dates).
          this._applyGlobalTenorFromStore('TENOR');
      }
    },
    'analyticsProStore.activeFilter': {
      immediate: false,
      handler(newVal) {
        if(this.rebuilding) return;
         this._applyGlobalTenorFromStore(newVal); 
      }
    },
      'analyticsProStore.sideFilter': {
      immediate: true,
      handler(arr) {
        this._applyGlobalSideFromStore(arr)
      },
    },
    'analyticsProStore.counterpartyFilter': {
      immediate: false,
      handler(names) {
        if (this.rebuilding) return;
        this._applyGlobalCounterpartyFromStore(names)
      },
    },
    'analyticsProStore.rfqPeriod': {
      immediate: false,
      handler() {
        if (this.rebuilding) return;
        this._applyRfqPeriodFromStore()
      },
    },
    'analyticsProStore.benchmark': {
      immediate: false,
      handler() {
        if (this.rebuilding) return;
        // Only the comparison window moved - the current one, and therefore
        // every chart, is untouched.
        this.refreshKpiVariations()
      },
    },
  },
  computed: {
    ...mapStores(useAnalyticsProStore),
    analytics() {
      return this.analyticsProStore.getAnalytics;
    },
  },
  mounted() {
        dc.config.defaultColors(
      d3
        .scaleOrdinal()
        .range([
          "#27c1e6",
          "#ffb300",
          "#2ecc71",
          "#e74c3c",
          "#9b59b6",
          "#1abc9c",
          "#f39c12",
          "#95a5a6",
          "#34495e",
          "#8e44ad",
        ])
    );
    this.init();
    this._resizeWatcher = createResizeWatcher(this.handleResize)
    ;[this.$refs.parentCurrency, this.$refs.parentTransaction, this.$refs.parentClient, this.$refs.kpi, this.$refs.piechart, this.$refs.parentSideVolume, this.$refs.parentClientMaturity]
      .forEach((el) => this._resizeWatcher.observe(el))
  },
  beforeDestroy() {
    this._resizeWatcher?.disconnect()
  },
  activated() {
    try {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          if (!this.ndx
            || dc.chartRegistry.list(CHART_GROUP).length === 0
            || this.builtGeneration !== this.analyticsProStore.getDatasetGeneration) {
            this.init(); // first mount, charts lost, or stale dataset
            return;
          }
          this.updateChartsSize();
          this._applyGlobalSideFromStore(this.analyticsProStore.sideFilter);
          this._applyGlobalCounterpartyFromStore(this.analyticsProStore.counterpartyFilter);
          this._applyRfqPeriodFromStore();
          this._applyGlobalTenorFromStore(this.analyticsProStore.activeFilter);
          safeRedrawAll(CHART_GROUP);
        });
      });
    } catch (e) {
      console.warn("Error refreshing dc.js charts on activate", e);
    }
  },
  deactivated() {
    this.clearPageFilters()
  },
  methods: {
    handleResize() {
      if (this.ndx && this.data.length) {
        this.updateChartsSize();
        safeRedrawAll(CHART_GROUP);
      }
    },
    updateChartsSize(){
        const doubleWidth = this.$refs.parentTransaction?.offsetWidth || 200;
        const clientWidth = this.$refs.parentClient?.offsetWidth || 200;
        const currencyWidth = this.$refs.parentCurrency?.offsetWidth ||  350;
        const kpiWidth = this.$refs.kpi?.offsetWidth;
        const pieWidth = this.$refs.piechart?.offsetWidth || doubleWidth;
        const sideWidth = this.$refs.parentSideVolume?.offsetWidth || doubleWidth;
        const clientMaturityWidth = this.$refs.parentClientMaturity?.offsetWidth || clientWidth;
        this.charts[0]?.width(currencyWidth);
        this.charts[0]?.rescale();
        this.charts[1]?.width(doubleWidth);
        this.charts[1]?.rescale();
        this.charts[2]?.width(pieWidth);
        this.charts[3]?.width(clientWidth);
        this.charts[4]?.width(sideWidth);
        this.charts[4]?.rescale();
        this.charts[5]?.width(clientMaturityWidth);


      return[doubleWidth, clientWidth, currencyWidth, kpiWidth, pieWidth, sideWidth, clientMaturityWidth]
    },
    // True only when this page actually has layout. While keep-alive holds it
    // deactivated the DOM is detached and every offsetWidth reads 0, so
    // updateChartsSize would fall back to 200/350px and build charts at a width
    // that has nothing to do with the card.
    hasLayout() {
      return (this.$refs.kpi?.offsetWidth || 0) > 0;
    },
    init() {
      // Building without layout produces charts sized to the fallbacks. Leave
      // builtGeneration stale instead: activated() compares it and rebuilds
      // once the page is on screen and measurable.
      if (!this.hasLayout()) return;

      this.rebuilding = true
      // try/finally is load-bearing, not defensive dressing: five sidebar
      // filter watchers bail on `if (this.rebuilding) return`. A throw anywhere
      // below used to leave the flag stuck true, and from then on the page
      // ignored side, period, counterparty and benchmark - silently, with the
      // charts still on screen from the half-finished build.
      try {
        // Deregister only the charts THIS build owns, not the whole group
        ;[...this.charts, ...this.kpiCharts].forEach((ch) => {
          if (!ch) return
          try { ch.filterAll?.() } catch (_) {}
          try { dc.deregisterChart(ch, CHART_GROUP) } catch (_) {}
        })
        this.charts = []
        this.kpiCharts = []

        this.data = Array.isArray(this.analyticsProStore.analytics) ? this.analyticsProStore.analytics  : [];
        this.tableData = {rows: this.data}
        this.builtGeneration = this.analyticsProStore.getDatasetGeneration;
        this.ndx = crossfilter(this.data);
        if(!this.ndx) this.ndx = crossfilter([])
        this.buildGlobalDimensions();
        this.renderAllCharts();
      } catch (e) {
        // Surfaced, not swallowed: a build that dies half way leaves the page
        // in a state worth knowing about.
        console.error('[FlowSight] Overview rebuild failed', e);
        this.builtGeneration = -1;
      } finally {
        this.rebuilding = false;
      }
    },
      buildGlobalDimensions() {
      const dimTable = this.ndx.dimension((d,i)=>{return i});
          // Global period filter dimension: tenorDays calculated per normalized row.
        const dimTenorDays = this.ndx.dimension(d => d.tenorDays);
      const dimSide = this.ndx.dimension(d=>d.side)
      // Global counterparty filter, driven by the sidebar dropdown.
      const dimCounterparty = this.ndx.dimension(d => String(d.counterparty || '').trim())
      // RFQ-date axis (sidebar "Período (data do RFQ)" + KPI benchmark). Kept
      // apart from dimTenorDays, which windows by maturity.
      const dimRfqDate = this.ndx.dimension(d => toDate(d.rfqtimestamp) || new Date(0))
        this.dim = { ...this.dim, dimTenorDays, dimSide, dimCounterparty, dimRfqDate, dimTable };
      // Built once from the FULL row set: the forward-fill of missing spots
      // needs a stable donor regardless of what is filtered - see
      // createEffectiveSpotMap.
      this._effectiveSpotByRow = createEffectiveSpotMap(this.ndx.all());
    },
    // Esvazia os containers que renderAllCharts desenha. Necessario porque
    // init() DESREGISTRA os charts do grupo dc antes de reconstruir: se a
    // reconstrucao nao desenha nada (dataset vazio), o SVG anterior fica na
    // tela orfao - nao pertence mais a nenhum chart, entao nunca mais e
    // redesenhado nem removido. Era o que se via ao trocar de produto: eixos
    // com as moedas do dataset antigo, barras fantasma e ticks "-0.00".
    clearChartHosts() {
      const ids = [
        '#currency', '#transactions', '#clients', '#side-volume', '#clients-maturity',
        '#total-vol', '#negotiated-vol', '#converted-vol', '#receita', '#markup',
        '#conversion-rate', '#negotiated-ticket', '#converted-ticket',
        '#negotiated-count', '#converted-count',
      ]
      ids.forEach((sel) => {
        const el = this.$el && this.$el.querySelector(sel)
        if (el) el.innerHTML = ''
      })
      ;[this.$refs.piechart, this.$refs.pieChartLegend].forEach((el) => {
        if (el) el.innerHTML = ''
      })
      this.totalRejected = 0
    },
    renderAllCharts() {
      if (!this.data.length) {
        this.clearChartHosts();
        return;
      }

      //screen size responsive
      const [doubleWidth, clientWidth, currencyWidth, kpiWidth, pieWidth, sideWidth, clientMaturityWidth] = this.updateChartsSize();
      const store = this.analyticsProStore

      // Visual charts (indices match updateChartsSize()'s this.charts[0..5]
      // width-setting and _applyGlobalSideFromStore()'s i===2/i===4 skip below).
      this.charts[0] = createCurrencyBarChart({ el: '#currency', ndx: this.ndx, chartGroup: CHART_GROUP, width: currencyWidth, color: this.sideColor })
      this.charts[1] = createStatusBarChart({ el: '#transactions', ndx: this.ndx, chartGroup: CHART_GROUP, width: doubleWidth, color: this.sideColor })
      this.charts[2] = createRejectionPieChart({ el: this.$refs.piechart, legendEl: this.$refs.pieChartLegend, ndx: this.ndx, store, chartGroup: CHART_GROUP, width: pieWidth, onTotalChange: (total) => { this.totalRejected = total } })
      this.charts[3] = createClientsVolumeChart({ el: '#clients', ndx: this.ndx, chartGroup: CHART_GROUP, width: clientWidth, color: this.sideColor, t: (key) => this.$t(key) })
      this.charts[4] = createSideVolumeChart({ el: '#side-volume', ndx: this.ndx, chartGroup: CHART_GROUP, width: sideWidth, store, t: (key) => this.$t(key) })
      this.charts[5] = createClientsMaturityChart({ el: '#clients-maturity', ndx: this.ndx, chartGroup: CHART_GROUP, width: clientMaturityWidth, color: this.sideColor, t: (key) => this.$t(key) })

      // KPI NumberDisplay charts.
      this.kpiCharts[0] = createTotalVolumeKpi({ el: '#total-vol', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth, store })
      this.kpiCharts[1] = createNegotiatedVolumeKpi({ el: '#negotiated-vol', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth, store })
      this.kpiCharts[2] = createConvertedVolumeKpi({ el: '#converted-vol', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth, store })
      this.kpiCharts[3] = createRevenueKpi({ el: '#receita', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth })
      this.kpiCharts[4] = createAverageSpreadKpi({ el: '#markup', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth, store })
      this.kpiCharts[5] = createConversionRateKpi({ el: '#conversion-rate', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth, store })
      this.kpiCharts[6] = createNegotiatedTicketKpi({ el: '#negotiated-ticket', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth })
      this.kpiCharts[7] = createConvertedTicketKpi({ el: '#converted-ticket', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth })
      this.kpiCharts[8] = createNegotiatedCountKpi({ el: '#negotiated-count', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth })
      this.kpiCharts[9] = createConvertedCountKpi({ el: '#converted-count', ndx: this.ndx, chartGroup: CHART_GROUP, width: kpiWidth })

      dc.chartRegistry.list(CHART_GROUP).forEach((ch) => {
        if (ch && typeof ch.on === "function") {
            // Synchronous: dc sets this chart's own _filters before firing
            // 'filtered', so this always reads an up-to-date snapshot.
            ch.on('filtered.globalFlag',()=>{
            const active = dc.chartRegistry.list(CHART_GROUP).some(c => c.filters?.().length)
            this.isFiltered = active ? true : false
            // The KPI values just moved, so the variation against the benchmark
            // has to move with them.
            this.refreshKpiVariations()
          })
        }
      })

      this.$nextTick(()=>{
        requestAnimationFrame(()=>{
          this._applyGlobalSideFromStore(this.analyticsProStore.sideFilter)
          this._applyGlobalCounterpartyFromStore(this.analyticsProStore.counterpartyFilter)
          this._applyRfqPeriodFromStore()
          this._applyGlobalTenorFromStore(this.analyticsProStore.activeFilter)
        })
          safeRenderAll(CHART_GROUP)
      })
    },

    // Windows the RFQ-date dimension to the sidebar's period. Recomputing the
    // benchmark afterwards is mandatory: it is measured by swapping THIS
    // dimension, so it has to be re-read whenever the current window moves.
    _applyRfqPeriodFromStore()
    {
      const { dimRfqDate } = this.dim || {};
      if (!dimRfqDate) return;
      const window = this.analyticsProStore.getRfqPeriodWindow;
      dimRfqDate.filterAll();
      if (window) dimRfqDate.filterFunction((d) => d >= window.from && d <= window.to);
      this.refreshKpiVariations();
      safeRedrawAll(CHART_GROUP);
    },
    // Reads the six KPIs for the current window and for the benchmark window,
    // through the same crossfilter state, and stores the deltas for the
    // template. Cheap enough to run on every filter change (two O(n) passes).
    refreshKpiVariations()
    {
      const { dimRfqDate } = this.dim || {};
      if (!this.ndx || !dimRfqDate) { this.kpiVariations = {}; return; }

      const currentWindow = this.analyticsProStore.getRfqPeriodWindow;
      const benchWindow = this.analyticsProStore.getBenchmarkWindow;
      if (!benchWindow) { this.kpiVariations = {}; return; }

      const current = measureKpis(this.ndx.allFiltered(), this._effectiveSpotByRow);
      const baseline = measureBenchmark({
        ndx: this.ndx,
        dimRfqDate,
        currentWindow,
        benchmarkWindow: benchWindow,
        effectiveSpotByRow: this._effectiveSpotByRow,
      });
      this.kpiVariations = buildKpiVariations(current, baseline);
    },
    // '' keeps the KPI in its normal white - no benchmark picked, or a
    // comparison window with no rows in it.
    // Variacao ARREDONDADA para as duas casas que o rotulo mostra, ou null quando
    // nao ha percentual. Cor e rotulo saem daqui para nao poderem discordar:
    // decidir a cor pelo valor cru pintaria de verde uma variacao de 0,001%,
    // que na tela aparece como "0,00%".
    kpiVarPct(entry)
    {
      if (!entry || !Number.isFinite(entry.pct)) return null;
      const rounded = Number(entry.pct.toFixed(2));
      // (-0.001).toFixed(2) e "-0.00", que vira -0 e imprimiria "-0.00%".
      return Object.is(rounded, -0) ? 0 : rounded;
    },
    kpiTrendClass(key)
    {
      const entry = this.kpiVariations?.[key];
      if (!entry || !entry.hasBaseline) return '';
      const pct = this.kpiVarPct(entry);
      if (pct !== null) {
        // Zero nao e alta: sem variacao, sem cor.
        if (pct === 0) return '';
        return pct > 0 ? 'kpi-up' : 'kpi-down';
      }
      // Baseline measured as exactly zero: no percentage exists, but the
      // direction does and is worth colouring.
      if (Number.isFinite(entry.current) && entry.current !== 0) {
        return entry.current > 0 ? 'kpi-up' : 'kpi-down';
      }
      return '';
    },
    kpiVarLabel(key)
    {
      const entry = this.kpiVariations?.[key];
      if (!entry) return '';
      if (!entry.hasBaseline) return this.$t('flowSightOverview.noBaseline');
      const pct = this.kpiVarPct(entry);
      if (pct !== null) {
        const sign = pct > 0 ? '+' : '';
        return `${sign}${pct.toFixed(2)}%`;
      }
      return this.$t('flowSightOverview.fromZero');
    },
    // Empty list = no filter (see analyticsStore.counterpartyFilter). filterAll()
    // first so a narrowing selection doesn't stack on the previous one.
    _applyGlobalCounterpartyFromStore(names = [])
    {
      const { dimCounterparty } = this.dim || {};
      if (!dimCounterparty) return;
      dimCounterparty.filterAll();
      // Applied unconditionally: the selection now lists every counterparty by
      // default, so an empty list means the user unticked them all.
      const selected = new Set(names);
      dimCounterparty.filterFunction((d) => selected.has(d));
      this.refreshKpiVariations();
      safeRedrawAll(CHART_GROUP);
    },
    _applyGlobalSideFromStore(arr)
    { 
      const { newAnalytics, mainColor } = this.analyticsProStore.getSideFilter(arr) || {};
      this.sideColor = mainColor;
      const {dimSide} = this.dim;
      if(!dimSide) return ;
      dimSide.filterAll();

      if (arr.length === 1) {
        const side = (arr[0] || '').toUpperCase();
        dimSide.filterFunction(d => (d || '').toUpperCase() === side);
      } else {
        dimSide.filterAll();
      }

    
      this.sideColor =
      arr.length === 1
        ? ((arr[0] || '').toUpperCase() === 'BUY' ? '#27c1e6' : '#ffb300')
        : '#2ecc71';

      this.charts.forEach((chart,i) => {
        if (i === 2 || i === 4) return;
      if (chart?.colors) chart.colors(this.sideColor);
      });

      this.refreshKpiVariations();
      this.scheduleRedraw();
    },
    _applyGlobalTenorFromStore(type) {
      // pode ser chamado antes de buildGlobalDimensions na 1ª montagem
        if (!this.dim || !this.dim.dimTenorDays) {
        // aplica depois que build ocorrer
          this.$nextTick(() => this._applyGlobalTenorFromStore(type));
        return;
      }
        const { dimTenorDays } = this.dim;
        dimTenorDays.filterAll();

      const range = this.analyticsProStore.getDateRange(
        type,
        this.analyticsProStore.customStart,
        this.analyticsProStore.customEnd
      );
      
      if (range) {
                // Inclusive tenorDays clamp from store: [startDays, endDays].
                dimTenorDays.filterFunction((d) => d >= range[0] && d <= range[1])
      };
      this.refreshKpiVariations();
      this.scheduleRedraw()
    },
    scheduleRedraw() {
      if (!this._scheduleRedrawFn) {
        this._scheduleRedrawFn = createScheduledRedraw(CHART_GROUP, () => true)
      }
      this._scheduleRedrawFn()
    },
    resetCurrentChart() {
      Object.values(this.charts).forEach((chart) => {
        if (chart && chart.filterAll) chart.filterAll();
      });
      this.isFiltered = false
      safeRenderAll(CHART_GROUP);
    },
   clearPageFilters() {
      this.analyticsProStore.setActiveFilter('ALL')
      this.resetCurrentChart()
    },
   redrawFilter()
   {
      this.clearPageFilters()
      if (!this.ndx || dc.chartRegistry.list(CHART_GROUP).length === 0) {
        console.warn('Charts stale, reinitializing...')
       this.$nextTick(() => {
        this.init()
        safeRenderAll(CHART_GROUP)
    })
      }
    }
  }
};
</script>

<style scoped>


.kpis {
  display: grid;
  gap: .4rem;
  /* 5 colunas, nao 3: com 10 KPIs o grid de 3 deixaria a ultima linha com um
     card solto. Em 5 sao duas linhas cheias - e a ALTURA do painel nao muda,
     que e o que mantem o alinhamento com a coluna de charts ao lado. */
  grid-template-columns: repeat(5, minmax(0, 1fr));
  width: 100%;
  container-type: inline-size;
  container-name: kpis;
}
.borders {
  padding: .5rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  height:100%;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;

}

.kpi-value-row {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  min-width: 0;
}
.kpi-value {
  color: #ffffff;
  font-size: clamp(.5rem, 6cqi, 1.15rem);
  font-weight: 700;
  line-height: 1.2;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}
.kpi-prefix,
.kpi-suffix {
  color: #fff;
  font-size: clamp(0.4rem, 3.5cqi, 1rem);
  font-weight: 400;
  line-height: 1.2;
  flex-shrink: 0;
}

.total-vol {
  border-left: 2px solid #ffb300;
}
.profit {
  border-left: 2px solid var(--success);
}
.bps {
  border-left: 2px solid #1bb8c0;
}
.conversion {
  border-left: 2px solid #9333ea;
}
.vol-convertido {
  border-left: 2px solid #ea334e;
}
.vol-negociado {
  border-left: 2px solid #ea7f33;
}

/*
  Uma cor por KPI, sem repeticao. As quatro novas ocupam as lacunas de matiz que
  as seis antigas deixavam (azul, lima, fucsia e indigo), e estao dispostas de
  modo que nenhum par vizinho no grid - lado a lado ou um sobre o outro - fique
  a menos de 50 graus de distancia.
*/
.ticket-negociado {
  border-left: 2px solid #3b82f6;
}
.rfq-negociada {
  border-left: 2px solid #a3e635;
}
.ticket-convertido {
  border-left: 2px solid #d946ef;
}
.rfq-convertida {
  border-left: 2px solid #6366f1;
}

/* Benchmark variation. The number, its prefix/suffix and the delta line all
   take the trend colour together - colouring only the digits leaves the "R$"
   and the "%" white and reads like a rendering bug.
   No .kpi-up/.kpi-down class means no benchmark picked, or a comparison window
   with no rows: the KPI keeps its default white. */
.kpi-var {
  font-size: clamp(0.35rem, 3cqi, 0.8rem);
  line-height: 1.2;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 1.2em;
}

.kpi-up .kpi-value,
.kpi-up .kpi-prefix,
.kpi-up .kpi-suffix,
.kpi-up .kpi-var {
  color: var(--success);
}

.kpi-down .kpi-value,
.kpi-down .kpi-prefix,
.kpi-down .kpi-suffix,
.kpi-down .kpi-var {
  color: var(--danger);
}

.vol-convertido .kpi-value,
.profit .kpi-value {
  font-size: calc(clamp(.4rem, 6cqi, 1.2rem) * 1.2);
}
.vol-convertido .kpi-prefix,
.profit .kpi-prefix {
  font-size: calc(clamp(0.4rem, 3.5cqi, 1.2rem) * 1.2);
}

.v-card {
  background-color: rgb(18, 19, 25);
  border: 1px solid rgb(33, 36, 46);
  padding: .5rem 1rem;
}

.charts-wrapp {
  display: flex;
}
.positiv {
  color: var(--success);
}
.negativ {
  color: var(--danger);
}
::v-deep(.dc-html-legend) {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 0.1rem;
  padding-bottom: 1rem;
  font-size: 13px;
  max-width: 100%;
}

::v-deep svg{
  width:100% !important;
  max-width: 100% !important;  
}

::v-deep(.x-axis-label){
  font-size: 11px;
}
::v-deep(.dc-legend text) {
  fill: white !important;
  font-size: 12px !important;
}
::v-deep(.dc-legend rect) {
  stroke: white;
  stroke-width: 1px;
}
::v-deep(.dc-chart, .axis text),
::v-deep(.dc-chart, .y-axis-label),
::v-deep(.dc-chart, .x-axis-label) {
  fill: white !important;
}

.dc-chart .y-axis-label,
.dc-chart .x-axis-label {
  fill: white !important; /* text color */
  font-size: 15px; /* optional size */
  font-weight: bold; /* optional weight */
}
#clients,
#clients-maturity,
#transactions,
#side-volume,
#pie-chart {
  position: relative;
}

.stacked-cards  {
  height: auto !important;
  flex: 0 0 auto;
}
.stacked-cards > .chart-card + .chart-card {
  margin-top: 12px;
}
#clients svg,
#clients-maturity svg {
  position: relative;
  z-index: 10 !important;
}

@container kpis (max-width: 520px) {
  .kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
@container kpis (max-width: 260px) {
  .kpis {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
}

@supports not (container-type: inline-size) {
  @media screen and (max-width: 950px) {
    .kpis {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  @media screen and (max-width: 450px) {
    .kpis {
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }
  }
}
</style>